import React, { useState, useEffect } from "react";

const providers = [
  { name: "Novomatic", logo: require("../../../assets/img/catalog/fortuna45/novomatic.png") },
  { name: "EGT Digital", logo: require("../../../assets/img/catalog/fortuna45/egtdigital.png") },
  { name: "Evolution", logo: require("../../../assets/img/catalog/fortuna45/evolution_gaming.png")},
  { name: "Pragmatic Play", logo: require("../../../assets/img/catalog/fortuna45/pragmatic.png") }
];

const generateUsername = () => {
  const a = Math.floor(Math.random() * 900) + 100;
  const b = Math.floor(Math.random() * 90) + 10;
  return `${a}***${b}`;
};

const generateAmount = () => {
  const amount = Math.floor(Math.random() * 9901) + 100;
  return amount.toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

const generateWin = () => ({
  username: generateUsername(),
  amount: generateAmount(),
  provider: providers[Math.floor(Math.random() * providers.length)],
});

const CARD_W = 168;
const CARD_H = 72;

const WinCard = ({ win }) => {
  const [flipped, setFlipped] = useState(false);

  useEffect(() => {
    const delay = Math.random() * 2500;
    let intervalId;

    const timeoutId = setTimeout(() => {
      intervalId = setInterval(() => {
        setFlipped((prev) => !prev);
      }, 3800);
    }, delay);

    return () => {
      clearTimeout(timeoutId);
      clearInterval(intervalId);
    };
  }, []);

  const cardBase =
    "absolute inset-0 rounded-lg bg-secondary-500/70 border border-secondary-50/50 overflow-hidden";

  return (
    <div style={{ perspective: "700px", width: CARD_W, height: CARD_H, flexShrink: 0 }}>
      <div
        style={{
          transformStyle: "preserve-3d",
          transition: "transform 0.75s cubic-bezier(0.4, 0, 0.2, 1)",
          transform: flipped ? "rotateY(180deg)" : "rotateY(0deg)",
          position: "relative",
          width: "100%",
          height: "100%",
        }}
      >
        {/* Ön yüz — Logo */}
        <div
          className={`${cardBase} flex items-center justify-center p-2`}
          style={{ backfaceVisibility: "hidden" }}
        >
          <img
            src={win.provider.logo}
            alt={win.provider.name}
            className="max-w-full max-h-full object-contain"
            onError={(e) => {
              e.currentTarget.style.display = "none";
              e.currentTarget.nextElementSibling.style.display = "flex";
            }}
          />
          <div
            className="hidden items-center justify-center text-white font-bold text-2xl w-full h-full"
          >
            {win.provider.name[0]}
          </div>
        </div>

        {/* Arka yüz — Bilgi */}
        <div
          className={`${cardBase} flex items-center px-3 py-2`}
          style={{
            backfaceVisibility: "hidden",
            transform: "rotateY(180deg)",
          }}
        >
          <div className="flex flex-col gap-0.5 whitespace-nowrap">
            <div className="flex items-center gap-1 text-white/90 text-xs">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="w-3 h-3 flex-shrink-0"
                viewBox="0 0 24 24"
                fill="currentColor"
              >
                <path d="M12 12c2.7 0 4.8-2.1 4.8-4.8S14.7 2.4 12 2.4 7.2 4.5 7.2 7.2 9.3 12 12 12zm0 2.4c-3.2 0-9.6 1.6-9.6 4.8v2.4h19.2v-2.4c0-3.2-6.4-4.8-9.6-4.8z" />
              </svg>
              <span>{win.username}</span>
            </div>
            <div className="text-secondary-50 font-bold text-sm leading-tight">
              {win.amount} $
            </div>
            <div className="text-white/70 text-xs leading-tight">
              {win.provider.name}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const WinningTicker = () => {
  const [winningData, setWinningData] = useState([]);

  useEffect(() => {
    setWinningData(Array.from({ length: 20 }, generateWin));
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setWinningData((prev) => [...prev, generateWin()]);
    }, 10000);
    return () => clearInterval(interval);
  }, []);

  if (!winningData.length) return null;

  return (
    <div className="overflow-hidden" dir="ltr">
      <div className="flex items-center">
        <div className="flex items-center gap-2 animate-scroll">
          {winningData.map((win, i) => (
            <WinCard key={i} win={win} />
          ))}
          {winningData.map((win, i) => (
            <WinCard key={`r-${i}`} win={win} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default WinningTicker;
